import { ref, createApp } from 'vue'
import { i18n } from 'locales'
import ConfirmModal from 'components/helper/ConfirmModal.vue'

const isModalActive = ref(false)

function askForConfirmation(options) {
  if (isModalActive.value) {
    return Promise.resolve(false)
  }

  isModalActive.value = true

  return new Promise((resolve) => {
    const container = document.createElement('div')
    document.body.appendChild(container)

    let app

    const props = {
      ...options,
      onConfirm: () => {
        cleanup()
        resolve(true)
      },
      onCancel: () => {
        cleanup()
        resolve(false)
      }
    }

    // Create an isolated app for the modal and install i18n so `useI18n` works
    app = createApp(ConfirmModal, props)
    app.use(i18n)
    app.mount(container)

    function cleanup() {
      isModalActive.value = false
      if (app) app.unmount()
      document.body.removeChild(container)
    }
  })
}

export function useConfirmModal() {
  return { askForConfirmation, isModalActive }
}
